import React from 'react';
import { Phone, MapPin, ShoppingBag } from 'lucide-react';
import { LINKS } from '../config/links';

const FloatingButtons = () => {
  const hasPhone = LINKS.phone && LINKS.phone.length > 0;
  const hasDirections = LINKS.directions && LINKS.directions.length > 0;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 md:hidden">
      <div className="flex items-center gap-2 bg-white/95 backdrop-blur-md rounded-full shadow-2xl p-2 border border-gray-200">
        {/* Bouton Commander (Uber Eats) - Toujours visible */}
        <a
          href={LINKS.uberEats}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-4 py-3 rounded-full font-semibold transition-all duration-300 active:scale-95 text-sm"
        >
          <ShoppingBag className="w-4 h-4" />
          <span>Commander</span>
        </a>

        {/* Bouton Appeler - Seulement si téléphone configuré */}
        {hasPhone && (
          <a
            href={`tel:${LINKS.phone}`}
            className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-3 rounded-full font-semibold transition-all duration-300 active:scale-95 text-sm"
          >
            <Phone className="w-4 h-4" />
            <span>Appeler</span>
          </a>
        )}
        
        {/* Bouton Itinéraire - Seulement si directions configurées */}
        {hasDirections && (
          <a
            href={LINKS.directions}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-gray-800 hover:bg-gray-900 text-white px-4 py-3 rounded-full font-semibold transition-all duration-300 active:scale-95 text-sm"
          >
            <MapPin className="w-4 h-4" />
            <span>Y aller</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default FloatingButtons;
